module.exports = "/assets/data/432dbbfb12f6667c1470e3863eb80ef0-BD2.data.json";